import { isEmpty } from "lodash"

import { ThemeEnum, TThemeStyles } from "../../types"

type TData = {
  [ThemeEnum.Light]: TThemeStyles
  [ThemeEnum.Dark]: TThemeStyles
}

type TErrors = {
  [ThemeEnum.Light]: Partial<TThemeStyles>
  [ThemeEnum.Dark]: Partial<TThemeStyles>
}

const isValidColor = (value: string): boolean => {
  if (typeof value !== "string" || !value.trim()) return false

  const trimmed = value.trim().toLowerCase()

  if (
    trimmed.startsWith("#") ||
    trimmed.startsWith("rgb(") ||
    trimmed.startsWith("rgba(") ||
    trimmed.startsWith("hsl(")
  ) {
    const strictRegex = new RegExp(
      [
        "^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$",
        "^rgb\\(\\s*(25[0-5]|2[0-4]\\d|1\\d\\d|\\d{1,2})\\s*,\\s*(25[0-5]|2[0-4]\\d|1\\d\\d|\\d{1,2})\\s*,\\s*(25[0-5]|2[0-4]\\d|1\\d\\d|\\d{1,2})\\s*\\)$",
        "^rgba\\(\\s*(25[0-5]|2[0-4]\\d|1\\d\\d|\\d{1,2})\\s*,\\s*(25[0-5]|2[0-4]\\d|1\\d\\d|\\d{1,2})\\s*,\\s*(25[0-5]|2[0-4]\\d|1\\d\\d|\\d{1,2})\\s*,\\s*(0|0?\\.\\d+|1(\\.0+)?)\\s*\\)$",
        "^hsl\\(\\s*\\d{1,3}\\s*,\\s*\\d{1,3}%\\s*,\\s*\\d{1,3}%\\s*\\)$",
      ].join("|")
    )
    return strictRegex.test(trimmed)
  }

  const s = new Option().style
  s.color = trimmed
  return s.color !== ""
}

export const validate = (data: TData): TErrors => {
  const errors: TErrors = {
    [ThemeEnum.Light]: {},
    [ThemeEnum.Dark]: {},
  }

  const lightTheme = data[ThemeEnum.Light]
  const darkTheme = data[ThemeEnum.Dark]

  Object.keys(lightTheme).forEach((key: string) => {
    if (!lightTheme[key]) errors[ThemeEnum.Light][key] = "Required"
    else if (!isValidColor(lightTheme[key]))
      errors[ThemeEnum.Light][key] = "Invalid format"
  })

  Object.keys(darkTheme).forEach((key: string) => {
    if (!darkTheme[key]) errors[ThemeEnum.Dark][key] = "Required"
    else if (!isValidColor(darkTheme[key]))
      errors[ThemeEnum.Dark][key] = "Invalid color"
  })

  if (isEmpty(errors[ThemeEnum.Light])) delete errors[ThemeEnum.Light]
  if (isEmpty(errors[ThemeEnum.Dark])) delete errors[ThemeEnum.Dark]

  return errors
}
